module.exports = __webpack_public_path__ + "media/images/logo-watermark-7d0f9f4bb5219b5eda9fa9523d45673b.png";